import { createTheme, adaptV4Theme } from '@mui/material/styles';

export const theme = createTheme(adaptV4Theme({
  palette: {
    primary: {
      main: '#2684FF',//blue
      light: '#57D9A3',//green
      dark: '#002884',
      contrastText: '#fff',
    },
    secondary: {
      light: '#ff7961',
      main: '#f44336',
      dark: '#ba000d',
      contrastText: '#000',
    },
  },
}));